import {Base} from "@/api/Base"

export class OtherListByIdAdv extends Base {
    path = "other/listByIdAdv"
}